// extracted by mini-css-extract-plugin
export default {"rating":"gz-z","numberOfStars":"hz-z","count":"iz-z","barGraphSpacing":"jz-z","barGraph":"kz-z"};